const MainFloat = theme => {
  return {
    position: 'relative',
    marginTop: '-40%',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-50%',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '-50%',
    },
    [theme.breakpoints.down('lg')]: {
      marginTop: '-40%',
    },
  }
}

export default MainFloat



// WEBPACK FOOTER //
// ./src/styles/mixins/mainfloat.js